export default __webpack_public_path__ + "8202de3b98ae80b52803149c8151711e.svg";